import React, { useEffect, useState } from 'react';
import { CategoriaCircularizacao } from '../interfaces/ICircularizacao';
import { CircularizacaoService } from '../services/CircularizacaoService';

interface Props {
  esteiraId: number;
  categoria: CategoriaCircularizacao;
  categoriaLabel: string;
  onFechar: () => void;
}

// Cards 09/10 do Épico Backend — RN-005: nenhum lembrete/cobrança automática é agendado sem uma
// política ATIVA para a categoria (ou geral da esteira). Esta tela só gerencia a política
// ESPECÍFICA desta categoria — a política geral (sem categoria) é um conceito mais amplo, fora do
// escopo desta tela por categoria.
const PoliticaCobrancaModal: React.FC<Props> = ({ esteiraId, categoria, categoriaLabel, onFechar }) => {
  const [carregando, setCarregando] = useState(true);
  const [ativa, setAtiva] = useState(false);
  const [diasLembretePreventivo, setDiasLembretePreventivo] = useState(2);
  const [diasCobrancaAtraso, setDiasCobrancaAtraso] = useState(1);
  const [considerarDiasUteis, setConsiderarDiasUteis] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    CircularizacaoService.listarPoliticasCobranca(esteiraId).then((politicas) => {
      const daCategoria = politicas.find((p) => p.categoria === categoria);
      if (daCategoria) {
        setAtiva(daCategoria.ativa);
        setDiasLembretePreventivo(daCategoria.diasLembretePreventivo);
        setDiasCobrancaAtraso(daCategoria.diasCobrancaAtraso);
        setConsiderarDiasUteis(daCategoria.considerarDiasUteis);
      }
      setCarregando(false);
    });
  }, [esteiraId, categoria]);

  const salvar = async () => {
    setSalvando(true);
    await CircularizacaoService.definirPoliticaCobranca(esteiraId, {
      categoria,
      ativa,
      diasLembretePreventivo,
      diasCobrancaAtraso,
      considerarDiasUteis,
    });
    setSalvando(false);
    setMensagem('Política de cobrança atualizada.');
  };

  return (
    <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onFechar()}>
      <div className='circ-modal' style={{ maxWidth: 460 }}>
        <div className='circ-modal-header'>
          <h4>Política de Cobrança Automática — {categoriaLabel}</h4>
          <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onFechar}>
            <i className='bi bi-x-lg' />
          </button>
        </div>
        <div className='circ-modal-body'>
          {carregando ? (
            <div className='text-muted text-center py-3'>Carregando...</div>
          ) : (
            <>
              <div className='circ-form-group'>
                <label className='d-flex align-items-center gap-2'>
                  <input type='checkbox' checked={ativa} onChange={(e) => setAtiva(e.target.checked)} />
                  Ativar lembretes e cobranças automáticas para esta categoria
                </label>
              </div>
              <div className='circ-form-group'>
                <label htmlFor='pol-dias-lembrete'>Dias antes do prazo para o lembrete (D-2)</label>
                <input
                  id='pol-dias-lembrete'
                  type='number'
                  min={0}
                  className='circ-form-control'
                  value={diasLembretePreventivo}
                  onChange={(e) => setDiasLembretePreventivo(Number(e.target.value))}
                />
              </div>
              <div className='circ-form-group'>
                <label htmlFor='pol-dias-cobranca'>Dias após o prazo para a cobrança (D+1)</label>
                <input
                  id='pol-dias-cobranca'
                  type='number'
                  min={0}
                  className='circ-form-control'
                  value={diasCobrancaAtraso}
                  onChange={(e) => setDiasCobrancaAtraso(Number(e.target.value))}
                />
              </div>
              <div className='circ-form-group'>
                <label className='d-flex align-items-center gap-2'>
                  <input type='checkbox' checked={considerarDiasUteis} onChange={(e) => setConsiderarDiasUteis(e.target.checked)} />
                  Considerar apenas dias úteis
                </label>
              </div>
              {mensagem && <div style={{ fontSize: 12.5, color: '#47586b' }}>{mensagem}</div>}
            </>
          )}
        </div>
        <div className='circ-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' onClick={onFechar}>
            Fechar
          </button>
          <button type='button' className='btn btn-sm btn-primary' disabled={carregando || salvando} onClick={salvar}>
            {salvando && <span className='spinner-border spinner-border-sm me-1' />}
            Salvar Política
          </button>
        </div>
      </div>
    </div>
  );
};

export default PoliticaCobrancaModal;
